export default __webpack_public_path__ + "static/media/Add-Ons.beaf293a.png";